<template>
  <div>
    <div class="section" v-if="!loadingPage.loading">
      <div class="container section__content">
        <h2 class="std__subtile">{{$t("zodiac_signs")}}</h2>
        <p
          class="std__subtile sm"
        >{{$t("by_click")}}</p>
        <div class="row">
          <div
            class="col-md-2 col-sm-4 col-4"
            v-for="zodiac in horoscopeData.data"
            :key="zodiac.key"
          >
            <router-link
              class="signIcon"
              :to="{ name: 'ZodiacDetails', params: { zodiac: zodiac.name.toLowerCase() } }"
            >
              <span class="signIcon__img" :style="{ '-webkit-mask': `url(${zodiac.icon})` }"></span>
              <span class="shadow"></span>
              <!-- <img :src="sunsign.icon" /> -->
              <div class="signIcon__label">{{zodiac.name}}</div>
              <div class="signIcon__date">{{zodiac.date}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section" v-if="!loadingPage.loading">
      <div class="container section__content">
        <h2 class="std__subtile">{{$t("element_signs")}}</h2>
        <div class="row">
          <div class="col-md-3 col-6" v-for="element in zodiacData.elements" :key="element.key">
            <router-link
              class="elementItem"
              :to="{ name: 'ElementsDetails', params: { element: element.element_name} }"
            >
              <img class="elementItem__icon" :src="element.icon" alt />
              <div class="signIcon__label">
                <span v-if="language==='english'">{{element.element_name}}</span>
                <span v-if="language==='arabic'">{{element.element_nameAR}}</span>
                <span v-if="language==='greek'">{{element.element_nameGR}}</span>
                <span v-if="language==='malay'">{{element.element_nameMY}}</span>
                <span v-if="language==='thai'">{{element.element_nameTH}}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
export default {
  data() {
    return {
      loading: true
    };
  },
  computed: mapGetters(["language"]),
  mounted(){
    console.log(this.$props.horoscopeData.data);
  },
  props: ["zodiacData", "loadingPage", "horoscopeData"]
};
</script>
<style lag="scss">
.elementItem {
  display: block;
  text-align: center;
  color: #fff;
}
.elementItem__icon {
  width: 100%;
  max-width: 80px;
  border-radius: 50%;
}
h3 {
  color: rgb(255, 230, 0);
}

.sunsign {
  color: white;
  margin-right: 5px;
  padding: 0px;
  font-size: 10px;
}

.form-group {
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/Zodiac.vue